<template>
  <section class="relative pt-16 bg-white">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <!-- Heading -->
      <div class="text-center mb-12">
        <span class="inline-block bg-blue-100 text-blue-800 text-sm px-4 py-2 rounded-full font-semibold mb-6">
          บริการเสริมสำหรับองค์กร
        </span>
        <h2 class="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
          บริการอื่นๆ ที่เรามี
          <span class="text-blue-600 block mt-1 text-3xl lg:text-4xl">ช่วยให้การอบรมพนักงานสมบูรณ์แบบ</span>
        </h2>
        <p class="text-xl text-gray-600 max-w-3xl mx-auto">
          นอกจาก KM แล้ว เรายังมีบริการอื่นๆ ที่จะทำให้การอบรมพนักงานของคุณประสบความสำเร็จ ทั้งเรื่องระบบ การผลิตเนื้อหา และการวัดผล
        </p>
  </div>
  </div>

  <!-- 2x2 Service Blocks - Compact & Simple Design -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-0">
    <article v-for="item in services" :key="item.key" class="relative group h-80 md:h-96 rounded-none overflow-hidden border-0">
          <!-- Background image -->
          <img :src="item.image" :alt="item.title" loading="lazy" decoding="async" class="absolute inset-0 w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-105" />
          
          <!-- Simple overlay with fade gradient from bottom - much higher fade -->
          <div class="absolute inset-0 bg-gradient-to-t from-black/85 from-20% via-black/70 via-50% via-black/40 via-75% to-black/10"></div>
          
          <!-- Service badge - Large & Centered Top -->
          <div class="absolute top-8 left-1/2 transform -translate-x-1/2">
            <div class="w-16 h-16 rounded-2xl bg-white/95 backdrop-blur-sm flex items-center justify-center shadow-xl border border-white/20">
              <component :is="item.icon" class="w-8 h-8 text-blue-600" />
            </div>
          </div>
          <!-- Content - Simple & Compact - Centered with natural gradient background -->
          <div class="absolute inset-0 flex flex-col justify-center items-center p-6 pt-20">
            <div class="text-center space-y-3 max-w-sm">
              <h3 class="text-xl md:text-2xl font-bold text-blue-500 leading-tight drop-shadow-lg">
                {{ item.title }}
              </h3>
              <p class="text-white/95 text-sm leading-relaxed drop-shadow-md">
                {{ item.description.slice(0, 200) }}
              </p>
            
              <!-- Simple buttons -->
              <!-- <div class="flex gap-2 mt-4 justify-center">
                <button @click="openSchedule('consult', { source: 'service', service: item.key })" 
                        class="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors shadow-lg">
                  ปรึกษา
                </button>
                <button @click="openSchedule('quote', { source: 'service', service: item.key })" 
                        class="px-4 py-2 border border-white/60 text-white hover:bg-white/15 text-sm font-medium rounded-lg transition-colors shadow-lg backdrop-blur-sm">
                  ราคา
                </button>
              </div> -->
            </div>
          </div>
        </article>
  </div>
  </section>
  
</template>

<script setup>
import { h } from 'vue'
import { useScheduleModal } from '~/composables/useScheduleModal'
const { openSchedule } = useScheduleModal()

// Small inline icons (Tailwind-friendly SVGs)
const IconERP = {
  name: 'IconERP',
  render() {
    return h(
      'svg',
      { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': '2', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', class: 'w-6 h-6' },
      [
        h('rect', { x: '3', y: '4', width: '18', height: '14', rx: '2' }),
        h('path', { d: 'M7 8h4M7 12h10' })
      ]
    )
  }
}

const IconMarketing = {
  name: 'IconMarketing',
  render() {
    return h(
      'svg',
      { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': '2', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', class: 'w-6 h-6' },
      [h('path', { d: 'M3 11l18-5-4 12-6-4-4 6z' })]
    )
  }
}

const IconWeb = {
  name: 'IconWeb',
  render() {
    return h(
      'svg',
      { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': '2', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', class: 'w-6 h-6' },
      [
        h('circle', { cx: '12', cy: '12', r: '10' }),
        h('path', { d: 'M2 12h20M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20' })
      ]
    )
  }
}

const IconMedia = {
  name: 'IconMedia',
  render() {
    return h(
      'svg',
      { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': '2', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', class: 'w-6 h-6' },
      [
        h('rect', { x: '3', y: '5', width: '18', height: '14', rx: '2' }),
        h('path', { d: 'M10 9l5 3-5 3z' })
      ]
    )
  }
}

const services = [
  {
    key: 'erp',
    title: 'วางระบบ ERP',
    subtitle: 'ERP Implementation',
    icon: IconERP,
  image: 'https://vue-project.sgp1.digitaloceanspaces.com/https://vue-project.sgp1.digitaloceanspaces.com/2025/08/1756449034304.png',
    description: 'วิเคราะห์กระบวนการ ทำ Blueprint วางแผนการย้ายข้อมูล และปรับแต่งโมดูลให้สอดคล้องกับทีมและธุรกิจของคุณ พร้อมอบรมการใช้งานและส่งมอบแบบครบถ้วน',
    features: [
      { name: 'วิเคราะห์กระบวนการ (Process Mapping)', desc: 'เข้าใจขั้นตอนงานจริง จับ Pain Points และกำหนด To‑Be' },
      { name: 'Data Migration Plan', desc: 'วางแผนและทดสอบการย้ายข้อมูลอย่างปลอดภัย' },
      { name: 'ปรับแต่งโมดูล/รายงาน', desc: 'Customize ตามความต้องการทีมใช้งาน' },
      { name: 'อบรมและเอกสารการใช้งาน', desc: 'Train ผู้ใช้และแอดมิน พร้อมคู่มือ' },
    ],
  },
  {
    key: 'marketing',
    title: 'การตลาดออนไลน์',
    subtitle: 'Online Marketing',
    icon: IconMarketing,
  image: 'https://vue-project.sgp1.digitaloceanspaces.com/https://vue-project.sgp1.digitaloceanspaces.com/2025/08/1756449034036.png',
    description: 'ขับเคลื่อนยอดผู้เรียนด้วยกลยุทธ์ดิจิทัล ครอบคลุมโฆษณา คอนเทนต์ และแคมเปญ CRM ผนวกฟีเจอร์ UTM/Tracking ของ LMS เพื่อวัดผลปลายทาง',
    features: [
      { name: 'แผนสื่อโฆษณา (Ads Plan)', desc: 'Google/Meta/TikTok ปรับตามเป้าหมาย' },
      { name: 'คอนเทนต์และแคมเปญ', desc: 'Creative, Landing Page, Email Journey' },
      { name: 'วัดผลครบวงจร', desc: 'เชื่อม UTM, Pixel, Conversion API' },
      { name: 'รายงานผลและปรับแผน', desc: 'สรุป KPI และข้อเสนอปรับปรุง' },
    ],
  },
  {
    key: 'web',
    title: 'พัฒนาเว็บไซต์',
    subtitle: 'Website Development',
    icon: IconWeb,
  image: 'https://vue-project.sgp1.digitaloceanspaces.com/https://vue-project.sgp1.digitaloceanspaces.com/2025/08/1756449033591.png',
    description: 'ออกแบบและพัฒนาเว็บไซต์/พอร์ทัลเชื่อม KM เน้นประสิทธิภาพ SEO และประสบการณ์ผู้ใช้ รองรับหลายภาษาและการขยายในอนาคต',
    features: [
      { name: 'UX/UI Design', desc: 'ออกแบบประสบการณ์และภาพลักษณ์มืออาชีพ' },
      { name: 'SEO & Performance', desc: 'Core Web Vitals และโครงสร้างข้อมูล' },
      { name: 'เชื่อมต่อ KM/API', desc: 'Single Sign‑On, Course Catalog, Webhooks' },
      { name: 'รองรับหลายภาษา', desc: 'i18n พร้อมจัดการคอนเทนต์' },
    ],
  },
  {
    key: 'media',
    title: 'สตูดิโอผลิตสื่อ',
    subtitle: 'Media Production Studio',
    icon: IconMedia,
  image: 'https://vue-project.sgp1.digitaloceanspaces.com/https://vue-project.sgp1.digitaloceanspaces.com/2025/08/1756449032908.png',
    description: 'ผลิตสื่อการเรียนรู้คุณภาพสูงทั้งวิดีโอ อินโฟกราฟิก แบบทดสอบ และสื่อโต้ตอบ เพื่อยกระดับการมีส่วนร่วมและผลลัพธ์การเรียนรู้',
    features: [
      { name: 'วิดีโอการสอน/สตูดิโอ', desc: 'ถ่ายทำ/ตัดต่อ พร้อม Motion/Subtitle' },
      { name: 'เอกสาร/อินโฟกราฟิก', desc: 'สรุปเนื้อหาเข้าใจง่ายตามแบรนด์' },
      { name: 'แบบทดสอบ/SCORM', desc: 'สร้าง Quiz และแพ็ก SCORM พร้อมนำเข้า' },
      { name: 'เสริมการมีส่วนร่วม', desc: 'สื่อโต้ตอบและกิจกรรมในคอร์ส' },
    ],
  },
]

</script>

<style scoped>
/* Keep visuals simple and consistent */
</style>
